module.exports = __webpack_public_path__ + "img/icon_map_38_off_010.541ade43.png";